import React, { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar } from "@/shell/Sidebar";

type Props = {
    /** Unused; kept for backward compatibility — title now lives inside each page's PageHeader. */
    title?: string;
    /** Unused; kept for backward compatibility. */
    subtitle?: string;
    fullBleed?: boolean;
    bleedClassName?: string;
    children: ReactNode;
};

export const Shell: React.FC<Props> = ({ fullBleed = false, bleedClassName, children }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const shellClass = fullBleed ? "shell shell--fullbleed" : "shell";
    const bleedClass = bleedClassName ? `shell__bleed ${bleedClassName}` : "shell__bleed";

    return (
        <div className={shellClass}>
            <a className="skip-link" href="#main-content">Saltar al contenido principal</a>
            <Sidebar isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
            <div className="shell__main">
                <button
                    type="button"
                    className="menu-fab"
                    onClick={() => setMenuOpen(true)}
                    aria-label="Open menu"
                >
                    <span className="material-symbols-outlined">menu</span>
                </button>
                {fullBleed ? (
                    <div className={bleedClass} id="main-content">{children}</div>
                ) : (
                    <main className="page" id="main-content">{children}</main>
                )}
            </div>
        </div>
    );
};
